import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";

interface CheckingProfileData {
  id: string;
  profileName: string;
  status: string;
  profileRemarks: string;
  deleteRemarks: string;
  projectType: string;
  checkingProfileValidations: CheckingProfileValidations[];
}

interface CheckingProfileValidations {
  id: string;
  createdDate: string;
  updatedDate: string | null;
  createdBy: string;
  updatedBy: string | null;
  deletedBy: string | null;
  deletedDate: null;
  isValidateNow: boolean;
  validations: ValidationItem;
}

type ValidationItem = {
  id: string;
  code: string;
  projectType: string;
  validationType: string;
  name: string;
  description: string;
  isValidateNow: boolean;
};

async function getCheckingProfile(queryFunctionContext: QueryFunctionContext) {
  const { queryKey } = queryFunctionContext;
  const [_, checkingProfileQueryKey] = queryKey;
  const { id } = checkingProfileQueryKey as { id: string };

  const response = await axiosInstance.get(
    `/abdrebuild/api/crud/checkingProfile/${id}`,
  );
  return response.data.data;
}

function useCheckingProfile(
  checkingProfileQueryKey: { id: string },
  options?: {
    enabled?: boolean;
  },
) {
  const { id } = checkingProfileQueryKey;
  return useQuery({
    ...options,
    queryKey: ["checking-profile", { id }],
    queryFn: getCheckingProfile,
  });
}

export { useCheckingProfile };
export type { ValidationItem, CheckingProfileData };
